import { omit } from "lodash"
import moment from "moment"
import { IAnswer, Question } from "../types/types"

export const validateProbability = (value: string) => {
  const proba = parseInt(value)
  if (proba < 0) return "Doit être un nombre positif"
  if (proba > 100) return "Doit être inférieur à 100"
  return undefined
}

export const validateConsultationDate = (date: string) => {
  if (date) {
    if (date.length === 10) {
      const todayDate = moment()
      const consultationDate = moment(date, "YYYY-MM-DD", true)

      if (consultationDate.isValid()) {
        if (consultationDate < todayDate) {
          return "Attention la date de consultation doit être dans le futur."
        }
      } else return "Format de la date jj/mm/aaaa"
    }
  }

  return undefined
}

type ConsistentQuestionsAndAnswers = {
  questions: Array<Question> | undefined
  answers: Array<IAnswer> | undefined
}

const getDefaultValueForQuestion = (question: Question) => {
  const dependentQuestion = dependentQuestions.find(
    (_q) => _q.question_reference === question.question_reference
  )
  return dependentQuestion?.defaultValue
}

export const checkQuestionsConsistency = (
  questions: Array<Question> | undefined,
  answers: Array<IAnswer> | undefined
): ConsistentQuestionsAndAnswers => {
  const _questions = questions?.map((_q) => {
    return {
      ..._q,
      disabled: answers
        ? determineQuestionDisabled(_q, questions, answers)
        : false
    }
  })

  const _answers = _questions?.map((_q) => {
    const ans = answers?.find((_ans) => _ans.question_id === _q.id)
    return _q.disabled
      ? {
          question_id: _q.id,
          value: getDefaultValueForQuestion(_q)
        }
      : ans
      ? ans
      : undefined
  })

  return {
    questions: _questions
      ?.filter((_q) => !_q.disabled)
      .map((_q) => omit(_q, "disabled")),
    answers: _answers?.filter((_ans): _ans is IAnswer => _ans !== undefined)
  }
}

const dependentQuestions = [
  {
    question_reference: "lumbar_implant_value",
    defaultValue: "",
    dependency: {
      question_reference: "lumbar_implant_presence",
      value: 0
    }
  },
  {
    question_reference: "first_stage_method",
    defaultValue: 0,
    dependency: {
      question_reference: "back_stage_operated",
      type: "number",
      value: 1
    }
  },
  {
    question_reference: "second_stage_method",
    defaultValue: 0,
    dependency: {
      question_reference: "back_stage_operated",
      type: "number",
      value: 2
    }
  },
  {
    question_reference: "first_stage_decompression",
    defaultValue: 0,
    dependency: {
      question_reference: "first_stage_method",
      mode: "enable",
      value: 1
    }
  },
  {
    question_reference: "first_stage_fusion",
    defaultValue: 0,
    dependency: {
      question_reference: "first_stage_method",
      mode: "enable",
      value: 2
    }
  },
  {
    question_reference: "second_stage_decompression",
    defaultValue: 0,
    dependency: {
      question_reference: "second_stage_method",
      mode: "enable",
      value: 1
    }
  },
  {
    question_reference: "second_stage_fusion",
    defaultValue: 0,
    dependency: {
      question_reference: "second_stage_method",
      mode: "enable",
      value: 2
    }
  }
]

const determineQuestionDisabled = (
  question: Question,
  questions: Array<Question>,
  answers: Array<IAnswer>
) => {
  const dependentQuestion = dependentQuestions.find(
    (dq) => dq.question_reference === question.question_reference
  )
  if (dependentQuestion) {
    const determiningQuestion = questions.find(
      (_q) =>
        dependentQuestion.dependency.question_reference ===
        _q.question_reference
    )
    if (determiningQuestion) {
      const answer = answers.find(
        (ans) => ans.question_id === determiningQuestion.id
      )

      if (dependentQuestion.dependency.type === "number") {
        if (answer) {
          if (Array.isArray(answer.value)) {
            return answer.value.length < dependentQuestion.dependency.value
          }
        }
        return true
      }

      if (dependentQuestion.dependency.mode === "enable") {
        if (answer) {
          if (Array.isArray(answer.value)) {
            return !answer.value.includes(dependentQuestion.dependency.value)
          }
          if (
            typeof answer.value === "string" ||
            typeof answer.value === "number"
          ) {
            return answer.value !== dependentQuestion.dependency.value
          }
        }
      }
      return answer ? answer.value === dependentQuestion.dependency.value : true
    }
  }
  return false
}
